import React from "react";
import { Tabs } from "antd";
import ScheduleContainer from "./ScheduleContainer";

const { TabPane } = Tabs;

export default class DoctorScheduleTabView extends React.Component {
  render() {
    const { doctorsDetail, getDetail, clinicId } = this.props;
    return (
      <div className="kc-tabs-view ">
        <React.Fragment>
          <ScheduleContainer
            doctorsDetail={doctorsDetail}
            getDetail={getDetail}
            scheduleType="regular"
            clinicId={clinicId}
          />
          {/* <ScheduleContainer
            doctorsDetail={doctorsDetail}
            getDetail={getDetail}
            scheduleType="discounted"
          /> */}
        </React.Fragment>
      </div>
    );
  }
}
